import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_CORE_WRITING_ASSIGNMENT_REQUEST = 'FETCH_CORE_WRITING_ASSIGNMENT_REQUEST';
export const FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS = 'FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS';
export const FETCH_CORE_WRITING_ASSIGNMENT_FAILURE = 'FETCH_CORE_WRITING_ASSIGNMENT_FAILURE';


const buildCoreWrittingAssignmentURL = (groupId) => buildUrl(`/groups/${groupId}/core-writing-assignments`);

export function fetchCoreWrittingAssignmentIfNeed(groupId) {
  const method = 'GET';
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method, url: buildCoreWrittingAssignmentURL(groupId) })) {
      return false;
    }

    return dispatch(fetchCoreWrittingAssignment(groupId));
  };
}

export function fetchCoreWrittingAssignment(groupId) {
  return (dispatch) => {
    const url = buildCoreWrittingAssignmentURL(groupId);
    const method = 'GET';

    return dispatch(fetchCoreWrittingAssignmentRequest()).payload
      .then((response) => dispatch(fetchCoreWrittingAssignmentSuccess(response)))
      .catch((error) => dispatch(fetchCoreWrittingAssignmentFailure(error)));

    function fetchCoreWrittingAssignmentRequest() {
      return ApiCall.createAction({
        type: FETCH_CORE_WRITING_ASSIGNMENT_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchCoreWrittingAssignmentSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_CORE_WRITING_ASSIGNMENT_SUCCESS,
        payload: response,
        url,
        method,
        groupId,
      });
    }

    function fetchCoreWrittingAssignmentFailure(error) {
      return ApiCall.createAction({
        type: FETCH_CORE_WRITING_ASSIGNMENT_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}




// WEBPACK FOOTER //
// ./data/WritingAssignment/CoreAndCatchUp/actions.js